const headerComponent = document.getElementsByClassName('header')[0];

// Header scroll
if (headerComponent) {
  const getScrollTop = () => window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  let prevScrollPos = getScrollTop();
  let isScrollTicking = false;

  function updateHeaderOnScroll() {
    const currentScrollPos = getScrollTop();
    const headerHeight = headerComponent.scrollHeight;

    if (currentScrollPos === 0) {
      headerComponent.classList.remove('scrolled');
      headerComponent.style.top = 0;
    } else {
      if (currentScrollPos > 100 || prevScrollPos > currentScrollPos) {
        headerComponent.classList.add('scrolled');
      }

      if (prevScrollPos > currentScrollPos) {
        headerComponent.style.top = 0;
      } else {
        headerComponent.style.top = `-${headerHeight + 3}px`;
      }
    }

    prevScrollPos = currentScrollPos;
    isScrollTicking = false;
  }

  function onScroll() {
    if (isScrollTicking) {
      return;
    }

    isScrollTicking = true;
    requestAnimationFrame(updateHeaderOnScroll);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // menu handlers

  // check mobile menu show/hide condition
  const mobileMenuStartPoint = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
          '--mobile-menu-start-point'
      )
  );
  let isMobileMenuEnable =
      window.outerWidth <= mobileMenuStartPoint ||
      document.querySelector('.header-mobile');

  const dropdownToggle = document.querySelectorAll('.dropdown-toggle');
  const soundLinks = document.querySelectorAll('.js-sound-link[data-has-tooltip="true"]');
  const soundTooltip = document.getElementById('header-sound-tooltip-floating');
  let activeSoundLink = null;

  function isDesktopTooltipEnabled() {
    return Boolean(soundTooltip) && window.innerWidth > mobileMenuStartPoint;
  }

  function hideSoundTooltip() {
    if (!soundTooltip) {
      return;
    }

    soundTooltip.classList.remove('is-visible', 'is-top');
    soundTooltip.setAttribute('aria-hidden', 'true');
    activeSoundLink = null;
  }

  function updateSoundTooltipPosition(link) {
    if (!link || !isDesktopTooltipEnabled()) {
      hideSoundTooltip();
      return;
    }

    const tooltipMargin = 12;
    const tooltipOffset = 14;
    const linkRect = link.getBoundingClientRect();
    const tooltipRect = soundTooltip.getBoundingClientRect();
    const linkCenter = linkRect.left + linkRect.width / 2;

    let left = linkCenter - tooltipRect.width / 2;
    left = Math.min(
      Math.max(left, tooltipMargin),
      window.innerWidth - tooltipRect.width - tooltipMargin
    );

    let top = linkRect.bottom + tooltipOffset;
    let isTop = false;

    if (top + tooltipRect.height > window.innerHeight - tooltipMargin) {
      top = linkRect.top - tooltipRect.height - tooltipOffset;
      isTop = true;
    }

    soundTooltip.classList.toggle('is-top', isTop);
    soundTooltip.style.left = `${Math.round(left)}px`;
    soundTooltip.style.top = `${Math.round(
      Math.max(top, tooltipMargin)
    )}px`;
    soundTooltip.style.setProperty(
      '--tooltip-arrow-left',
      `${Math.max(16, Math.min(linkCenter - left, tooltipRect.width - 16))}px`
    );
    soundTooltip.classList.add('is-visible');
    soundTooltip.setAttribute('aria-hidden', 'false');
    activeSoundLink = link;
  }

  function updateSoundTooltips() {
    if (activeSoundLink) {
      updateSoundTooltipPosition(activeSoundLink);
      return;
    }

    hideSoundTooltip();
  }

  soundLinks.forEach((link) => {
    ['mouseenter', 'focus'].forEach((eventName) => {
      link.addEventListener(eventName, () => updateSoundTooltipPosition(link));
    });

    ['mouseleave', 'blur'].forEach((eventName) => {
      link.addEventListener(eventName, () => hideSoundTooltip());
    });
  });

  window.addEventListener('scroll', updateSoundTooltips, { passive: true });

  dropdownToggle.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      if (isMobileMenuEnable) {
        const menuItem = this.closest('.menu-item.dropdown');
        const dropdownMenu = this.nextElementSibling;

        // close all opened sub menu
        const activeDropdowns = document.querySelectorAll(
            '.menu-item.dropdown.active .dropdown-menu'
        );
        activeDropdowns.forEach((menu) => {
          menu.style.display = 'none';
          menu.closest('.dropdown').classList.remove('active');
        });

        // open current submenu
        menuItem.classList.toggle('active');
        if (menuItem.classList.contains('active')) {
          e.preventDefault();
          dropdownMenu.style.display = 'block';
        }
      }
    });
  });

  // toggle menu handler
  function menuToggleFunc() {
    const menuToggle = document.querySelector('.menu-toggle');
    const navbarNav = document.querySelector('.navbar-nav');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');

    headerComponent.classList.toggle('is-open-menu');
    menuToggle.classList.toggle('active');
    navbarNav.classList.toggle('active');
    headerCloseWrapper.classList.toggle('active');

    // LockScroll when burger open and enable when closed and enable scroll on menu
    if (scrollLock.getScrollState()) {
      scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
      scrollLock.addScrollableSelector('.simplebar-content-wrapper');
    } else {
      scrollLock.enablePageScroll();
    }
  }

  // menu update function
  function updateMenu() {
    isMobileMenuEnable =
        window.outerWidth <= mobileMenuStartPoint ||
        document.querySelector('.mobile-header');

    updateSoundTooltips();

    if (!isMobileMenuEnable) {
      const dropdownMenus = document.querySelectorAll('.dropdown-menu');
      dropdownMenus.forEach((menu) => {
        menu.style.display = '';
      });

      const headerCloseWrapper = document.querySelector(
          '.header-close-wrapper'
      );
      headerCloseWrapper.classList.remove('active');

      const activeMenuItems = document.querySelectorAll('.menu-item.active');
      activeMenuItems.forEach((item) => {
        item.classList.remove('active');
      });

      const navbarNav = document.querySelector('.navbar-nav');
      navbarNav.classList.remove('active');

      const menuToggle = document.querySelector('.menu-toggle');
      menuToggle.classList.remove('active');

      headerComponent.classList.remove('is-open-menu');

      // LockScroll when burger open and enable when closed
      scrollLock.enablePageScroll();
    }
  }

  window.addEventListener('resize', updateMenu);
  window.addEventListener('orientationchange', updateMenu);

  // end of toggle menu handler

  const menuToggle = document.querySelector('.menu-toggle');
  const headerCloseWrapper = document.querySelector('.header-close-wrapper');

  menuToggle.addEventListener('click', menuToggleFunc);
  headerCloseWrapper.addEventListener('click', menuToggleFunc);

  updateHeaderOnScroll();
  updateSoundTooltips();
}
